import React from 'react';
import PropTypes from 'prop-types';
import ReduxModal from 'components/reduxModal';
import i34 from 'assets/images/i34.svg';
import { Trans, withTranslated } from "components";

export const MODAL_ID = 'order-create-success';

const CreateOrderInfo = ({ close, t }) => (
  <ReduxModal
    id={MODAL_ID}
  >
    {(Modal) => (
      <div>
        <Modal.IconHeading icon={i34} />
        <Modal.Heading title={t("GOTOWE")} subtitle={t("Dziękujemy za złożenie zamówienia")} />
        <Modal.Text>
          <Trans>Obecnie oczekuje ono na realizację. Dopóki przycisk ANULUJ jest aktywny, możliwe jest zrezygnowanie z całości lub części zamówienia.</Trans>
        </Modal.Text>
        <Modal.Footer>
          <button type="button" onClick={close} className="full-btn has-margin-left"><Trans>OK, rozumiem</Trans></button>
        </Modal.Footer>
      </div>
    )}
  </ReduxModal>
);

CreateOrderInfo.propTypes = {
  close: PropTypes.func.isRequired
}

export default withTranslated(CreateOrderInfo);


// WEBPACK FOOTER //
// ./src/components/globalModals/CreateOrderInfo.jsx